import { b as t, r as S, d as o, e as i, f as E, g as p, h as m, l as e, a, i as s, c as C, p as T, q as g, j as A, m as _, n as v, S as I, k as R, o as N } from "./xometry-outlined-DI5U9ZaE.js";
import "./ActionsControls-BrOv771p.js";
import "./AttachmentListView-DHZl-g6p.js";
import "./AttachmentView-CgsYQoZZ.js";
import "./CommonMessage-O3X6ahzz.js";
import "./FileExtensionIcon-BjXIuwJw.js";
import "./InlineFilePreviewListView-BGso7tb8.js";
import "./InlineFilePreviewView-DUO9MJCk.js";
import "react/jsx-runtime";
import "clsx";
import "./LocaleIcon.const-2pFJMoZs.js";
import "react";
import "./getCentsSeparatorByCurrencyCode.mjs";
import "./getCurrencyCodeBySymbol.mjs";
import "./getCurrencyCodeFromString.mjs";
import "./getCurrencyCodeRTL.mjs";
import "./getCurrencySymbolByCode.mjs";
import "./getCurrencySymbolPlaceByCode.mjs";
import "./getCurrencySymbolSeparatorByCode.mjs";
import "big.js";
import "./getSeparatorByCurrencyCode.mjs";
import "./stringToBigFormat.mjs";
import "./moneyUtils.consts.mjs";
import "./Money.context.mjs";
import "./usePageLifecycle.consts.mjs";
import "./ErrorBoundary.context.mjs";
import { EMessengerTaskType as r } from "./index34.mjs";
const X = {
  [r.CALL]: t,
  [r.GENERAL]: S,
  [r.CHECKING_MATERIAL_CERTIFICATE]: o,
  [r.CHECKING_MEASUREMENT_PROTOCOL]: i,
  [r.CHECK_STATUS]: E,
  [r.CREATE_DOCUMENT]: p,
  [r.TALK_TO_CUSTOMER]: m,
  [r.TALK_TO_PARTNER]: e,
  [r.REQUEST_APPROVE]: a,
  [r.DISCUSS_ISSUE]: s,
  [r.CHANGES_IN_DEAL]: C,
  [r.SHIPPING]: T,
  [r.CHECKPOINT]: g,
  [r.DRAWING]: A,
  [r.PLACING_REPEAT_DEAL]: _,
  [r.REPLACING_REQUEST]: v,
  [r.PLACING_ISSUES]: I,
  [r.INVOICE_ISSUE]: R,
  [r.REVENUE_FORECAST_DIFF]: N
};
export {
  X as TASK_TYPE_ICONS
};
//# sourceMappingURL=taskTypeIcons.mjs.map
